import type { GameThemeColors } from './types';

const FALLBACK_COLORS: GameThemeColors = {
  background: '#0b0e11',
  surface: '#181c20',
  primary: '#017cee',
  success: '#3fb950',
  danger: '#ff6b6b',
  graphNode: '#017cee',
  graphEdge: 'rgba(244, 246, 248, 0.55)',
};

export function getThemeColors(): GameThemeColors {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return FALLBACK_COLORS;
  }

  const styles = window.getComputedStyle(document.body);
  const read = (name: string, fallback: string) => {
    const value = styles.getPropertyValue(name).trim();
    return value || fallback;
  };

  return {
    background: read('--bui-bg-app', FALLBACK_COLORS.background),
    surface: read('--bui-bg-neutral-1', FALLBACK_COLORS.surface),
    primary: read('--bui-accent-bg', FALLBACK_COLORS.primary),
    success: read('--bui-fg-positive', FALLBACK_COLORS.success),
    danger: read('--bui-fg-negative', FALLBACK_COLORS.danger),
    graphNode: read('--bui-accent-bg', FALLBACK_COLORS.graphNode),
    graphEdge: read('--bui-fg-secondary', FALLBACK_COLORS.graphEdge),
  };
}
